import lf from 'lovefield'

export function const_installations (schemaBuilder) {
  schemaBuilder.createTable('const_installations')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('libelle_court', lf.Type.STRING)
      .addColumn('prestation_equipement', lf.Type.STRING)
      .addColumn('nb_personnes', lf.Type.NUMBER) // nouveau au 2017/11 BC
      .addColumn('q', lf.Type.INTEGER)
      .addColumn('s', lf.Type.INTEGER)
      .addColumn('e', lf.Type.INTEGER)
      .addColumn('duree_installation', lf.Type.INTEGER)
      .addColumn('duree_installation_km', lf.Type.INTEGER)
      .addColumn('desinstallation', lf.Type.INTEGER)
      .addColumn('duree_desinstallation', lf.Type.INTEGER)
      .addColumn('cout_fixe', lf.Type.INTEGER)
      .addColumn('cout_fixe_ml', lf.Type.INTEGER)
      .addColumn('cout_jour', lf.Type.INTEGER)
      .addColumn('cout_mois', lf.Type.INTEGER)
      .addColumn('cout_mois_km', lf.Type.INTEGER)
      .addColumn('regle', lf.Type.STRING)
      .addColumn('quantification', lf.Type.BOOLEAN)
      .addColumn('groupe', lf.Type.INTEGER)
      .addColumn('groupe_libelle', lf.Type.STRING)
      .addPrimaryKey(['id'])
      .addNullable(['prestation_equipement', 'nb_personnes', 'q', 's', 'e', 
      				'duree_desinstallation', 'duree_installation_km',
      				'desinstallation', 'duree_desinstallation', 
      				'cout_fixe', 'cout_fixe_ml', 'cout_jour', 'cout_mois', 'cout_mois_km',
      				'regle', 'groupe', 'groupe_libelle']);
}


/*

CREATE TABLE IF NOT EXISTS `const-humidites` (
  `code` varchar(10) NOT NULL COMMENT 'SEC / NEUTRE / HUMIDE',
  `nom` varchar(30) NOT NULL,
  PRIMARY KEY (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8;

*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constInstallations.schema.js